export var durationTokens = {
  immediate: 0,
  fast: 100,
  medium: 200,
  slow: 400,
  slower: 600
};